import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/express-add-ons-docs/express-add-ons-docs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "addonuisdkappcurrentuser"
    }}>{`addOnUISdk.app.currentUser`}</h1>
    <p>{`Provides access to the currently logged in user.`}</p>
    <h2 {...{
      "id": "methods"
    }}>{`Methods`}</h2>
    <h3 {...{
      "id": "userid"
    }}>{`userId()`}</h3>
    <p>{`Retrieve the current user of the host application (Adobe Express).`}</p>
    <h4 {...{
      "id": "signature"
    }}>{`Signature`}</h4>
    <p><inlineCode parentName="p">{`userId(): Promise<string>`}</inlineCode></p>
    <h4 {...{
      "id": "return-value"
    }}>{`Return Value`}</h4>
    <p>{`A resolved `}<inlineCode parentName="p">{`Promise`}</inlineCode>{` containing the `}<inlineCode parentName="p">{`userId`}</inlineCode>{` of the current user.`}</p>
    <h4 {...{
      "id": "example-usage"
    }}>{`Example Usage`}</h4>
    <CodeBlock slots="heading, code" repeat="2" languages="JavaScript" mdxType="CodeBlock" />
    <h4 {...{
      "id": "javascript"
    }}>{`JavaScript`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import addOnUISdk from "https://express.adobe.com/static/add-on-sdk/sdk.js";

addOnUISdk.ready.then(async () => {
  const userId = await addOnUISdk.app.currentUser.userId();
  console.log("Current Userid: " + userId);
});
`}</code></pre>
    <h4 {...{
      "id": "output"
    }}>{`Output`}</h4>
    <p><inlineCode parentName="p">{`Current Userid: 3cda976828a4a90d13b0f38b1f8a59b1d6845cccfc48037fb30bb75d3ef67d36`}</inlineCode></p>
    <h3 {...{
      "id": "ispremiumuser"
    }}>{`isPremiumUser()`}</h3>
    <p>{`Indicates if the current user is a premium user.`}</p>
    <h4 {...{
      "id": "signature-1"
    }}>{`Signature`}</h4>
    <p><inlineCode parentName="p">{`isPremiumUser(): Promise<boolean>`}</inlineCode></p>
    <h4 {...{
      "id": "return-value-1"
    }}>{`Return Value`}</h4>
    <p>{`A resolved `}<inlineCode parentName="p">{`Promise`}</inlineCode>{` containing a boolean value indicating if the user is a premium user or not.`}</p>
    <h4 {...{
      "id": "example-usage-1"
    }}>{`Example Usage`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import addOnUISdk from "https://express.adobe.com/static/add-on-sdk/sdk.js";

addOnUISdk.ready.then(async () => {
  const isPremiumUser = await addOnUISdk.app.currentUser.isPremiumUser();
  if (!isPremiumUser) {
    // User not premium, allow only non-premium features only
  }
});
`}</code></pre>
    <h3 {...{
      "id": "isanonymoususer"
    }}>{`isAnonymousUser()`}</h3>
    <p>{`Determine whether the current user is browsing as a guest (not logged in).`}</p>
    <h4 {...{
      "id": "signature-2"
    }}>{`Signature`}</h4>
    <p><inlineCode parentName="p">{`isAnonymousUser(): Promise<boolean>;`}</inlineCode></p>
    <h4 {...{
      "id": "return-value-2"
    }}>{`Return Value`}</h4>
    <p>{`Returns a `}<inlineCode parentName="p">{`Promise`}</inlineCode>{` that resolves to a boolean indicating whether the user is anonymous.`}</p>
    <h4 {...{
      "id": "example-usage-2"
    }}>{`Example Usage`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import addOnUISdk from "https://express.adobe.com/static/add-on-sdk/sdk.js";

addOnUISdk.ready.then(async () => {
  const isAnonymousUser = await addOnUISdk.app.currentUser.isAnonymousUser();
  if (isAnonymousUser) {
    // User is not logged in - show guest level restricted features
    console.log("User is anonymous, some features may be limited.");
  } else {
    // User is logged in - show full features
    console.log("User is logged in.");
  }
});
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      